import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "TemperatureWarm.svg",
  "use": "TemperatureWarm.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"TemperatureWarm.svg\"><path d=\"M32,60a11.987,11.987,0,0,1-8-20.9251V14A8,8,0,0,1,40,14V39.0749A11.9869,11.9869,0,0,1,32,60ZM40.0007,48a7.977,7.977,0,0,0-3.2117-6.4A1.9746,1.9746,0,0,1,36,40.0174V14A4,4,0,0,0,28,14V40.0174A1.9746,1.9746,0,0,1,27.211,41.6a7.9976,7.9976,0,1,0,12.79,6.4ZM34,18v22.184a3.82,3.82,0,0,0,1.6075,3.0286,6,6,0,1,1-7.2151,0A3.82,3.82,0,0,0,30,40.1841V18a2,2,0,0,1,4,0Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol